import React from 'react';

import WrappedSignInForm from 'components/HomePage/SignInForm';
import authPageBg from 'assets/auth-page-bg.jpg';
import PageTitle from 'shared/PageTitle';

const SignInPage = () => {
  return (
    <div>
      <PageTitle title="Login" />
      <div
        className="sign-in-page bg-dark-grey auth-page"
        style={{ backgroundImage: `url(${authPageBg})` }}>
        <div className="row no-margin justify-content-center align-items-center">
          <div className="col-md-5 col-lg-5 col-sm-10">
            <WrappedSignInForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;



// WEBPACK FOOTER //
// ./src/components/HomePage/SignInPage.js